import PageLayout from '../../components/feature/PageLayout';
import PageHero from '../../components/feature/PageHero';
import SEO from '../../components/feature/SEO';
import CalculadoraWizard from './components/CalculadoraWizard';
import { Link } from 'react-router-dom';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Calculadora de Presupuesto – Taller Mecánico Kevin Alberto Ronda',
  url: `${siteUrl}/calculadora`,
  description:
    'Calcula el precio orientativo de cualquier reparación o servicio para tu coche en Ronda, Málaga. Taller Kevin Alberto.',
  inLanguage: 'es',
  isPartOf: { '@type': 'WebSite', url: siteUrl },
};

const CalculadoraPage = () => (
  <PageLayout>
    <SEO
      title="Calculadora de Presupuesto Taller Ronda | Taller Mecánico Kevin Alberto"
      description="Descubre el precio orientativo de tu reparación en segundos. Elige servicio, tipo de vehículo y calcula tu presupuesto estimado en Ronda, Málaga."
      keywords="presupuesto taller Ronda, precio reparación coche Ronda, calculadora taller mecánico Málaga"
      canonical="/calculadora"
      jsonLd={[jsonLd]}
    />
    <PageHero
      tag="Herramienta gratuita"
      title="Calcula tu"
      titleAccent="Presupuesto"
      subtitle="Sin llamadas ni visitas previas. Elige el servicio y tu vehículo y obtén una estimación real al instante."
      breadcrumb="Calculadora"
      bgImage="https://public.readdy.ai/ai/img_res/0bbbfa59b5e9082fb082b47ed1288e53.jpg"
    />
    <CalculadoraWizard />

    {/* Disclaimer + CTA strip */}
    <section className="bg-zinc-900/50 border-t border-zinc-800 py-12 px-4 md:px-6">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <i className="ri-shield-star-line text-yellow-400 text-lg" />
          <h4 className="text-white text-sm font-bold uppercase tracking-widest">Presupuesto gratis en taller</h4>
        </div>
        <p className="text-zinc-500 text-sm leading-relaxed mb-6 max-w-2xl mx-auto">
          Esta calculadora ofrece precios <strong className="text-zinc-300">orientativos</strong>. Para obtener el precio exacto y definitivo, pásate por el taller o escríbenos — siempre sin compromiso y en menos de 24 horas.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="tel:+34666365922"
            className="inline-flex items-center gap-2 border border-zinc-700 text-zinc-300 hover:border-zinc-500 hover:text-white text-xs font-bold uppercase tracking-widest px-6 py-3 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line text-yellow-400" />
            +34 666 36 59 22
          </a>
          <Link
            to="/contacto"
            className="inline-flex items-center gap-2 bg-yellow-400 text-black hover:bg-yellow-300 text-xs font-bold uppercase tracking-widest px-6 py-3 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Pedir presupuesto exacto <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  </PageLayout>
);

export default CalculadoraPage;
